import {
    FileObject,
    FileObjectIndexModel,
    FileObjectIndexOutputDTO,
    FileObjectMetadataUpdateOutputDTO,
    FileObjectMoveModel,
    FileObjectStorageInfoOutputDTO,
    FileObjectUpdateMetaModel,
    FileObjectUserFolderOutputDTO,
    FoDeleteApiV1UserFolderFileObjectDeleteParams,
    FolderCreateModel,
    FolderCreateOutputDTO,
    FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetParams,
    GetAllUserFoldersApiV1UserFolderFolderGetParams,
    GetAllUserFoldersOutputDTO,
    UserFolderMoveOutputDTO,
} from '../swagger/dtoGateway'
import { deleteRequest, getRequest, postRequest } from './config'
import { USER_FOLDER_FILES_URL, USER_FOLDER_URL } from './endpoints.constants'

export const getFilesUser = async (params): Promise<FileObjectUserFolderOutputDTO> => {
    const response = await getRequest<FileObjectUserFolderOutputDTO>(
        USER_FOLDER_FILES_URL,
        params,
        false,
    )
    return response.data
}

export const deleteFile = async (params: FoDeleteApiV1UserFolderFileObjectDeleteParams) => {
    const response = await deleteRequest<FileObject>(
        `${USER_FOLDER_FILES_URL}?prefix=${params.prefix}`,
        false,
    )
    return response.data
}

export const postIndexFile = async (data: FileObjectIndexModel) => {
    const response = await postRequest<FileObjectIndexModel, FileObjectIndexOutputDTO>(
        `${USER_FOLDER_FILES_URL}/index`,
        data,
        false,
    )
    return response.data
}

export const updateFileMeta = async (data: FileObjectUpdateMetaModel) => {
    const response = await postRequest<FileObjectUpdateMetaModel, FileObjectMetadataUpdateOutputDTO>(
        `${USER_FOLDER_FILES_URL}/update_meta`,
        data,
        false,
    )
    return response.data
}

export const getFolderList = async (
    params: GetAllUserFoldersApiV1UserFolderFolderGetParams,
): Promise<GetAllUserFoldersOutputDTO> => {
    const response = await getRequest<GetAllUserFoldersOutputDTO>(
        `${USER_FOLDER_URL}/folder`,
        params,
        false,
    )
    return response.data
}

export const postFolder = async (data: FolderCreateModel) => {
    const response = await postRequest<FolderCreateModel, FolderCreateOutputDTO>(
        `${USER_FOLDER_URL}/folder`,
        data,
        false,
    )
    return response.data
}

export const moveFileOrFolder = async (data: FileObjectMoveModel) => {
    const response = await postRequest<FileObjectMoveModel, UserFolderMoveOutputDTO>(
        `${USER_FOLDER_URL}/move`,
        data,
        false,
    )
    return response.data
}

export const getStorage = async (
    params: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetParams,
): Promise<FileObjectStorageInfoOutputDTO> => {
    const response = await getRequest<FileObjectStorageInfoOutputDTO>(
        `${USER_FOLDER_FILES_URL}/storage_info`,
        params,
        false,
    )
    return response.data
}
